import React, { useState, useEffect } from 'react';

function getBarColor(color) {
  // Accepts 'red', 'orange', 'green', 'blue', etc.
  // Can be extended for more color options
  switch (color) {
    case 'red':
      return 'bg-red-500';
    case 'orange':
      return 'bg-orange-400';
    case 'green':
      return 'bg-green-500';
    case 'blue':
      return 'bg-blue-500';
    case 'yellow':
      return 'bg-yellow-400';
    default:
      return 'bg-gray-400';
  }
}

export default function BlockMetrics({ block, className = '', isEditing, settingsFunnel }) {
  // block.metrics: array of { percent, description, color }
  // fallback for demo

  console.log('BlockMetrics - block.columns:', block.columns);
  console.log('BlockMetrics - block:', block);
  
  const metrics = block.metrics && Array.isArray(block.metrics) && block.metrics.length > 0
    ? block.metrics
    : [
        { id: 1, percent: 75, description: '75% das pessoas tem esse problema', color: 'red' },
        { id: 2, percent: 20, description: '20% das pessoas não tem esse problema', color: 'orange' },
         
      ];

  // Limit to 4 columns
  const columns = block.columns || 2;
  console.log('Final columns value:', columns);

  // State for animated percentages
  const [animatedPercentages, setAnimatedPercentages] = useState(
    metrics.map(() => 0)
  );

  // Animation effect - restart when metrics OR columns change
  useEffect(() => {
    const duration = 2000; // 2 seconds
    const steps = 60; // 60 steps for smooth animation
    const stepDuration = duration / steps;
    
    let currentStep = 0;
    
    const animate = () => {
      currentStep++;
      const progress = currentStep / steps;
      
      // Ease-out animation curve
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      setAnimatedPercentages(
        metrics.map(metric => Math.round(metric.percent * easeOut))
      );
      
      if (currentStep < steps) {
        setTimeout(animate, stepDuration);
      }
    };
    
    // Start animation after a small delay
    const timeout = setTimeout(animate, 100);
    
    return () => clearTimeout(timeout);
  }, []); // Add columns to dependencies

  // Get grid columns class based on columns count (similar to BlockQuiz)
  const getGridColsClass = (columns) => {
    switch (columns) {
      case 1:
        return 'flex flex-col gap-4';
      case 2:
        return 'grid grid-cols-2 gap-4';
      case 3:
        return 'grid grid-cols-3 gap-4';
      case 4:
        return 'grid grid-cols-4 gap-4';
      default:
        return 'grid grid-cols-2 gap-4';
    }
  };

  const gridClass = getGridColsClass(columns);

  return (
    <div className={`w-full ${gridClass} ${className}  `} >
      {metrics.slice(0, 4).map((metric, idx) => (
        <div
          key={idx}
          className="flex flex-col items-center rounded-xl border border-gray-200 p-4"
        >
          <div className="flex flex-col items-center mb-2 mt-4 w-full">
            <div className="relative flex flex-col items-center w-14 h-28">
              {/* Bar background */}
              <div className="absolute bottom-0 w-full h-full rounded-xl bg-gray-100" />
              {/* Bar fill */}
              <div
                className={`absolute bottom-0 w-full  rounded-b-xl transition-all duration-150 ${getBarColor(metric.color)}`}
                style={{
                  height: `${Math.max(0, Math.min(100, animatedPercentages[idx] || 0))}%`,
                  zIndex: 2,
                }}
              />
              {/* Percent label */}
              <div
                className="absolute top-0 left-1/2 -translate-x-1/2 text-xs font-bold   rounded px-2 py-1"
                style={{ zIndex: 3, marginTop: '-0', color: settingsFunnel.secondaryColor }}
              >
                {animatedPercentages[idx] || 0}%
              </div>
            </div>
          </div>
          <div className="text-center text-sm mt-2" style={{color: settingsFunnel.textColor, fontFamily: settingsFunnel.font }} >
            {metric.description}
          </div>
        </div>
      ))}
    </div>
  );
}

 